<script lang="ts" setup>
  const { matches: matchLargeDesktop } = useMatchMedia(ScreenWidth.largeDesktop)
  const { matches: matchDesktop } = useMatchMedia(ScreenWidth.desktop)

  const logoProperties = computed<{
    height: number
    width: number
    icon: string
    class: string
  }>(() => {
    if (matchLargeDesktop.value) {
      return {
        height: 47,
        width: 251,
        icon: 'logo-full',
        class: 'large',
      }
    } else if (matchDesktop.value) {
      return {
        height: 47,
        width: 47,
        icon: 'logo-small',
        class: 'large',
      }
    } else {
      return {
        height: 30,
        width: 30,
        icon: 'logo-small',
        class: 'small',
      }
    }
  })

</script>

<template>
  <NuxtLink
    to="/"
    class="c-responsive-logo"
  >
    <ClientOnly>
      <SvgIcon
        class="c-header-logo"
        v-bind="logoProperties"
      />
    </ClientOnly>
  </NuxtLink>
</template>

<style scoped>
.c-responsive-logo {
  display: flex;
  align-items: center;
  justify-content: center;

  .c-icon {
    margin-right: 2rem;

    &.small {
      width: 30px;
      height: 30px;
      margin: 1rem 1rem 1rem 0;
    }
  }
}
</style>
